// extracted by mini-css-extract-plugin
module.exports = {"ErrorPage":"styles_ErrorPage__2RxEk"};